import * as z from "zod";
import { MEETING_STATUS_VALUES } from "@/lib/constants/meeting-statuses";

// Meeting-specific schema - comprehensive with all database fields
export const meetingSchema = z
  .object({
    title: z.string().min(1, "Title is required."),
    description: z.string().optional(),
    start_time: z.date(),
    end_time: z.date(),
    location: z.string().optional(),
    meeting_type: z.enum(["call", "video_call", "in_person", "other"]),
    status: z.enum(MEETING_STATUS_VALUES),
    attendees: z.array(z.string()).optional(),
    notes: z.string().optional(),
  })
  .refine((data) => data.end_time > data.start_time, {
    message: "End time must be after start time",
    path: ["end_time"],
  });
